<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('settings.eventStatus.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button btn-class="btn-sm" type="new" btn-text="settings.eventStatus.create" @click="openEventStatusModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_event_status" style="margin-top: 13px !important; cursor:pointer">
            <thead>
              <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <th class="min-w-200px">{{ $t('settings.eventStatus.name')}}</th>
                <th class="w-100px">{{ $t('action') }}</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <EventStatusModal id="create_event_status_modal" @created="fetchDatas" />
    <EventStatusModal id="edit_event_status_modal" @created="fetchDatas" :data="formUpdateData" :edit="true"/>
</template>

<script setup>
import {nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import EventStatusModal from "./modals/EventStatusModal";

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  name: '',
  description: '',
  permission_ids: []
})

onMounted(() => {
  fetchDatas()
})

watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')

  table.value = $("#kt_datatable_event_status").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: Ls.get('pageLength') ?? 5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + "/get/event/status/datatable",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "name" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(true){
            render+='<a data-id="'+ e.id +'"  href="javascript:;"   class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" ></i></a>'
          }
          if(true){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).off("click", "#kt_datatable_event_status .edit_btn").on("click", "#kt_datatable_event_status .edit_btn", async(e) => {
    await store.dispatch('eventStatus/getEventStatus', e.target.getAttribute('data-id')).then((res) => {
      let data = res.data.data

      if (!data) return;

      formUpdateData.value.id =data.id
      formUpdateData.value.name = data.name
      formUpdateData.value.description = data.description

      let permissionIds = []
      if(data.permission) {
        data.permission?.forEach((item) => {
          permissionIds[item.id] = true
        })
      }
      formUpdateData.value.permission_ids = permissionIds

      $('#edit_event_status_modal').modal('toggle')
    })
  });

  $(document).off("click", "#kt_datatable_event_status .delete_btn").on("click", "#kt_datatable_event_status .delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    deleteEventStatus(id)
  });
}

function openEventStatusModal() {
  $('#create_event_status_modal').modal('toggle')
}

async function deleteEventStatus(id) {
    showSwal(
      i18n.global.t('settings.eventStatus.deleted_title'),
      i18n.global.t('settings.eventStatus.deleted_text')
    ).then( async (result) => {
        if (result.value) {
            try {
                await store.dispatch('eventStatus/deleteEventStatus', id)
                table.value.ajax.reload()
                window.toastr['success'](i18n.global.t("settings.eventStatus.deleted_successfully"))
            }catch (e) {
            }
        }
  })
}
</script>
